import React from 'react';
import { TrStyle } from './style';

export default function LineTableYear({ title, firstLink, secondLink }) {
  return (
    <TrStyle>
      <td>{title}</td>
      <td>
        <a href={firstLink}>D</a> <a href={secondLink}>R</a>
      </td>
    </TrStyle>
  );
}
